// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var MM_provers = require("../mm-utils/MM_provers.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var Expln_utils_jsonParse = require("../../rescript-utils/main/Expln_utils_jsonParse.bs.js");

var apiRef = {
  contents: undefined
};

function api(param) {
  return apiRef.contents;
}

var funcNameGetAllSteps = "editor.getAllSteps";

var funcNameProveBottomUp = "editor.proveBottomUp";

var fun = {
  editor: {
    getAllSteps: funcNameGetAllSteps,
    proveBottomUp: funcNameProveBottomUp
  }
};

function labelsToExprs(st, labels) {
  return labels.reduce((function (res, label) {
                if (res.TAG !== /* Ok */0) {
                  return res;
                }
                var stmt = MM_wrk_editor.editorGetStmtByLabel(st, label);
                if (stmt === undefined) {
                  return {
                          TAG: /* Error */1,
                          _0: "Cannot find a step by label '" + label + "'"
                        };
                }
                var expr = stmt.expr;
                if (expr !== undefined) {
                  res._0.push(expr);
                  return res;
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: "Internal error: the step with label '" + label + "' doesn't have expr."
                        };
                }
              }), {
              TAG: /* Ok */0,
              _0: []
            });
}

function makeShowError(funcName, showError, msg) {
  Curry._1(showError, "" + funcName + ": " + msg + "");
}

function updateEditorApi(state, showError, canStartProvingBottomUp, startProvingBottomUp) {
  apiRef.contents = (function (param, param$1) {
      if (param === funcNameGetAllSteps) {
        return state.stmts.map(function (stmt) {
                    return Js_dict.fromArray([
                                [
                                  "id",
                                  stmt.id
                                ],
                                [
                                  "label",
                                  stmt.label
                                ],
                                [
                                  "isHyp",
                                  stmt.typ === /* E */0
                                ],
                                [
                                  "jstf",
                                  stmt.jstfText
                                ],
                                [
                                  "jstfParsed",
                                  Belt_Result.mapWithDefault(MM_wrk_editor.parseJstf(stmt.jstfText), null, (function (jstf) {
                                          if (jstf !== undefined) {
                                            return Js_dict.fromArray([
                                                        [
                                                          "args",
                                                          jstf.args.map(function (prim) {
                                                                return prim;
                                                              })
                                                        ],
                                                        [
                                                          "asrt",
                                                          jstf.label
                                                        ]
                                                      ]);
                                          } else {
                                            return null;
                                          }
                                        }))
                                ],
                                [
                                  "stmt",
                                  MM_wrk_editor.contToStr(stmt.cont)
                                ]
                              ]);
                  });
      } else if (param === funcNameProveBottomUp) {
        var showError$1 = function (param$2) {
          return makeShowError(param, showError, param$2);
        };
        if (canStartProvingBottomUp) {
          var parseResult = Expln_utils_jsonParse.fromJson(param$1, (function (__x) {
                  return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                return {
                                        delayBeforeStartMs: Expln_utils_jsonParse.intOpt(d, "delayBeforeStartMs", undefined, undefined, undefined),
                                        stepToProve: Expln_utils_jsonParse.str(d, "stepToProve", undefined, undefined, undefined),
                                        debugLevel: Expln_utils_jsonParse.intOpt(d, "debugLevel", undefined, undefined, undefined),
                                        args0: Expln_utils_jsonParse.arr(d, "args0", (function (__x) {
                                                return Expln_utils_jsonParse.asStr(__x, undefined, undefined, undefined);
                                              }), undefined, undefined, undefined),
                                        args1: Expln_utils_jsonParse.arr(d, "args1", (function (__x) {
                                                return Expln_utils_jsonParse.asStr(__x, undefined, undefined, undefined);
                                              }), undefined, undefined, undefined),
                                        frmsToUse: Expln_utils_jsonParse.arrOpt(d, "frmsToUse", (function (__x) {
                                                return Expln_utils_jsonParse.asStr(__x, undefined, undefined, undefined);
                                              }), undefined, undefined, undefined),
                                        maxSearchDepth: Expln_utils_jsonParse.$$int(d, "maxSearchDepth", undefined, undefined, undefined),
                                        lengthRestrict: Expln_utils_jsonParse.str(d, "lengthRestrict", (function (str) {
                                                var match = MM_provers.lengthRestrictFromStr(str);
                                                if (match !== undefined) {
                                                  return {
                                                          TAG: /* Ok */0,
                                                          _0: str
                                                        };
                                                } else {
                                                  return {
                                                          TAG: /* Error */1,
                                                          _0: "lengthRestrict must be one of: No, LessEq, Less."
                                                        };
                                                }
                                              }), undefined, undefined),
                                        allowNewStmts: Expln_utils_jsonParse.bool(d, "allowNewStmts", undefined, undefined, undefined),
                                        allowNewVars: Expln_utils_jsonParse.bool(d, "allowNewVars", undefined, undefined, undefined),
                                        allowNewDisjForExistingVars: Expln_utils_jsonParse.bool(d, "allowNewDisjForExistingVars", undefined, undefined, undefined),
                                        maxNumberOfBranches: Expln_utils_jsonParse.intOpt(d, "maxNumberOfBranches", undefined, undefined, undefined)
                                      };
                              }), undefined, undefined, undefined);
                }), undefined, undefined, undefined);
          if (parseResult.TAG === /* Ok */0) {
            var apiParams = parseResult._0;
            var stmtToProve = state.stmts.find(function (stmt) {
                  return stmt.label === apiParams.stepToProve;
                });
            if (stmtToProve !== undefined) {
              var msg = labelsToExprs(state, apiParams.args0);
              if (msg.TAG === /* Ok */0) {
                var msg$1 = labelsToExprs(state, apiParams.args1);
                if (msg$1.TAG === /* Ok */0) {
                  Curry._1(startProvingBottomUp, {
                        delayBeforeStartMs: Belt_Option.getWithDefault(apiParams.delayBeforeStartMs, 1000),
                        stmtId: stmtToProve.id,
                        debugLevel: Belt_Option.getWithDefault(apiParams.debugLevel, 0),
                        bottomUpProverParams: {
                          asrtLabel: undefined,
                          frmsToUse: apiParams.frmsToUse,
                          maxSearchDepth: apiParams.maxSearchDepth,
                          lengthRestrict: MM_provers.lengthRestrictFromStrExn(apiParams.lengthRestrict),
                          allowNewDisjForExistingVars: apiParams.allowNewDisjForExistingVars,
                          allowNewStmts: apiParams.allowNewStmts,
                          allowNewVars: apiParams.allowNewVars,
                          args0: msg._0,
                          args1: msg$1._0,
                          maxNumberOfBranches: apiParams.maxNumberOfBranches
                        }
                      });
                } else {
                  Curry._1(showError$1, msg$1._0);
                }
              } else {
                Curry._1(showError$1, msg._0);
              }
            } else {
              Curry._1(showError$1, "Cannot find a step with label '" + apiParams.stepToProve + "'");
            }
          } else {
            Curry._1(showError$1, parseResult._0);
          }
        } else {
          Curry._1(showError$1, "Cannot start proving bottom-up because either there are syntax errors in the editor or edit is in progress.");
        }
        return null;
      } else {
        Curry._1(showError, "Unknown api function " + param + "");
        return null;
      }
    });
}

exports.api = api;
exports.fun = fun;
exports.updateEditorApi = updateEditorApi;
/* MM_provers Not a pure module */
